import { SimulationStatus } from '@/api';
import { BaseModal } from '@/components/base-modal';
import { connectColors } from '@/theme/colors';
import { Box, Text } from '@lego/klik-ui';
import type { RefObject } from 'react';

type PublishSimulationModalProps = {
  isOpen: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
  onConfirmPublish: () => void;
  isPublishing: boolean;
  currentStatus?: SimulationStatus;
};

const SKIP_REVIEW_STATUSES: SimulationStatus[] = [
  SimulationStatus.Draft,
  SimulationStatus.LocalReview,
];

export const PublishSimulationModal = ({
  isOpen,
  triggerRef,
  onClose,
  onConfirmPublish,
  isPublishing,
  currentStatus,
}: PublishSimulationModalProps) => {
  const skipsReview =
    currentStatus != null && SKIP_REVIEW_STATUSES.includes(currentStatus);

  return (
    <BaseModal
      isOpen={isOpen}
      triggerRef={triggerRef}
      onClose={onClose}
      title="Publish Simulation?"
      leftButtonText="Continue editing simulation"
      rightButtonProps={{
        text: 'Confirm & Publish simulation',
        onClick: onConfirmPublish,
        loading: isPublishing,
      }}
    >
      {skipsReview && (
        <Box
          padding="12px"
          marginBottom="12px"
          borderRadius="4px"
          backgroundColor={connectColors.core.yellow[50]}
        >
          <Text fontWeight="medium" fontSize="sm">
            Publishing from{' '}
            {currentStatus === SimulationStatus.Draft
              ? 'Draft'
              : 'Global Proposal'}{' '}
            skips local market input. Are you sure?
          </Text>
        </Box>
      )}
      <Text fontWeight="medium">
        Publishing will upload the prices to the Actuals and finalize the
        simulation. After publishing, edits won't be possible, and the
        simulation will be labeled as &nbsp;
        <b>
          <i>Approved</i>
        </b>
        .
      </Text>
    </BaseModal>
  );
};
